import React from 'react';
import PropTypes from 'prop-types';
import { useEnableNewFulfillmentPlanActivity } from '../../feature-flags/hooks/enable-new-fulfillment-plan-activity';
import FulfillmentPlanActivityComponent from './component';
import NewFulfillmentPlanActivityComponent from './new-component';

const FulfillmentPlanActivityContainer = ({ fulfillmentPlanId, className = '' }) => {
  const enableNewFulfillmentPlanActivity = useEnableNewFulfillmentPlanActivity();
  if (enableNewFulfillmentPlanActivity) {
    return <NewFulfillmentPlanActivityComponent fpid={fulfillmentPlanId} />;
  }
  return <FulfillmentPlanActivityComponent className={className} fpid={fulfillmentPlanId} />;
};

FulfillmentPlanActivityContainer.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default FulfillmentPlanActivityContainer;
